module.exports = __webpack_public_path__ + "static/media/lecture.930a958e.jpg";